import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * Renders LLM output as markdown with the compact chat styling (.chat-md in
 * App.css). Use for assistant messages everywhere they're displayed; user
 * messages stay plain text.
 */
export function MarkdownText({ text }: { text: string }) {
  return (
    <div className="chat-md">
      <ReactMarkdown>{text}</ReactMarkdown>
    </div>
  );
}
